import React from 'react';
import { motion } from 'framer-motion';
const CALENDAR_URL = 'https://calendar.app.google/PYPdcRoYne7QrNJA7';
export function CtaFinalSection() {
  return <section className="py-32 px-4 sm:px-6 lg:px-8 relative overflow-hidden border-t border-white/5" data-id="element-5">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/10 rounded-full blur-[100px] pointer-events-none" data-id="element-6" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-7">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center" data-id="element-8">
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-gold mb-12 leading-tight" data-id="element-9">
            Tu expertise jurídico merece clientes que puedan pagarlo.
          </h2>

          <a href={CALENDAR_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full sm:w-auto px-10 py-5 text-xl font-bold text-carbon bg-gold hover:bg-gold-light transition-all duration-300 rounded-lg shadow-[0_0_30px_rgba(242,183,5,0.4)] hover:shadow-[0_0_50px_rgba(242,183,5,0.6)] hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-carbon" data-id="element-10">
            QUIERO CASOS CALIFICADOS AHORA
          </a>

          <p className="mt-6 font-body text-base text-gray-400" data-id="element-11">
            Diagnóstico gratuito de 15 minutos
          </p>
        </motion.div>
      </div>
    </section>;
}